import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ConvertHelper } from '@barthauer/abc/core';
import { PersistenceService } from '@barthauer/abc/core/data';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MtWorkType } from '../../models/MtWorkType';
import { WorkState } from '../../models/WorkWizardOptions';
import { ValueWrapperViewModel } from '../../services/valueWrapper';
import { WorkService } from '../../services/work.service';

@Component({
  selector: 'basys-opera-wizards-create-works-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
  standalone: false,
})
export class ConfigurationComponent implements OnInit, OnDestroy {
  objectKey;
  public resAsync: Promise<ResourceSet>;
  public res = ResourceSet.Empty;

  private _workTypeId?: string;
  @Input() public set workTypeId(id: string | undefined) {
    if (this._workTypeId !== id) {
      this._workTypeId = id;
    }
  }
  public get workTypeId(): string | undefined {
    return this._workTypeId;
  }
  @Output() workTypeIdChange = new EventEmitter<string>();
  @Output() workExecTimeSelection = new EventEmitter<number | null>();

  private _status?: WorkState;
  @Input() public set status(status: WorkState | undefined) {
    if (this._status !== status) {
      this._status = status;
    }
  }
  public get status(): WorkState | undefined {
    return this._status;
  }
  @Output() statusChange = new EventEmitter<WorkState>();

  public workTypeData: any;
  public statusData: any;
  public currentWorkType?: MtWorkType;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private persistenceService: PersistenceService,
    private workService: WorkService,
    private resourceService: ResourceManagerService,
  ) {
    this.resAsync = this.resourceService.getResourceSet('opera-wizards');
  }

  async ngOnInit(): Promise<void> {
    this.res = await this.resAsync;
    this.objectKey = new ValueWrapperViewModel(this.persistenceService);
    this.workService.createWorkTypeAsDropDownListQuery().subscribe((result: any) => {
      this.workTypeData = result;
    });

    this.objectKey = new ValueWrapperViewModel(this.persistenceService);
    this.workService
      .queryPicklistItems('state')
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        this.statusData = result.Data;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  public onWorkTypeChanged(eventArgs: any): void {
    this.workTypeId = ConvertHelper.toString(eventArgs.value);
    this.workTypeIdChange.emit(this.workTypeId);
    this.workService
      .queryWorkType(this.workTypeId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((mtWorkType) => {
        this.currentWorkType = mtWorkType;
        this.workExecTimeSelection.emit(this.currentWorkType.execTime);
      });
  }

  public onStatusChanged(eventArgs: any): void {
    this.status = Number(ConvertHelper.toString(eventArgs.value)) as WorkState;
    this.statusChange.emit(this.status);
  }
}
